import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";
import { CerrixDialogComponent } from "../cerrix-dialog/cerrix-dialog.component";
import { CerrixTextareaComponent } from "@app/shared/atoms/cerrix-textarea/cerrix-textarea.component";

@Component({
    selector: "cerrix-textarea-dialog",
    imports: [CerrixButtonComponent, CerrixDialogComponent, CerrixTextareaComponent],
    templateUrl: "./cerrix-textarea-dialog.component.html",
    styleUrl: "./cerrix-textarea-dialog.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixTextareaDialogComponent {
    @Input() public name: string;
    @Input() public dataUiid: string;
    @Input() public title: string;
    @Input() public readOnly: boolean | null = null;
    @Input() public value: string;
    @Output() public cancel = new EventEmitter<void>();
    @Output() public confirm = new EventEmitter<string>();

    public onConfirm(): void {
        this.confirm.emit(this.value);
    }
}
